import { defineNuxtPlugin } from "#app";
import { useRuntimeConfig } from "#imports";
export default defineNuxtPlugin(async (nuxtApp) => {
  const config = useRuntimeConfig();
  if (!config.public.matomo?.siteId) {
    return;
  }
  const { default: VueMatomo } = await import("vue-matomo");
  nuxtApp.vueApp.use(VueMatomo, {
    host: "//analytics.webcontact.de",
    siteId: config.public.matomo.siteId,
    // Enables automatically registering pageviews on the router
    router: nuxtApp.$router,
    enableLinkTracking: true,
    requireConsent: false,
    trackInitialView: true,
    disableCookies: true,
    requireCookieConsent: false,
    enableHeartBeatTimer: false,
    debug: false
  });
});
